import './owl.carousel.min';

$ = jQuery;

function scrollToAnchor(element) {
  if (!element.length) {
    return false;
  }

  $('html,body').animate({scrollTop: element.offset().top}, 1000);
}

function initMap() {
  const icon = new L.Icon({
    iconUrl: zahradnicentra.site_url + '/app/themes/zahradnicentra/images/location-pin.svg',
    iconSize: [19, 26], // size of the icon
    iconAnchor: [10, 26], // point of the icon which will correspond to marker's location
    popupAnchor: [0, -13] // point from which the popup should open relative to the iconAnchor

  })
  let map = L.map('map-canvas').setView([49.19784086374528, 16.583511203385495], 13);
  let arrayOfCoordinates = [];

  L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 19,
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
  }).addTo(map);

  $.each(zahradnicentra_map.items, function (index, item) {
    arrayOfCoordinates.push([item.lat, item.lng]);
    let marker = L.marker([item.lat, item.lng], {icon: icon}).addTo(map);
    marker.bindPopup(item.popup_html);
  });

  let bounds = new L.LatLngBounds(arrayOfCoordinates);
  map.fitBounds(bounds);
}

$(document).ready(function () {
  if (typeof zahradnicentra_map !== "undefined") {
    initMap();
  }

  $('.js-languages-switcher').click(function (e) {
    $(this).toggleClass('open');
  });

  $('.js-toggle-modal').click(function (e) {
    e.preventDefault();
    let id = $(this).data('id');

    $('body').toggleClass('noscroll');
    $(id).toggle();
  });

  $('.js-tabs-menu a').click(function (e) {
    e.preventDefault();
    let index = $(this).parent().data('index');

    $('.js-tabs-menu .active').removeClass('active');
    $(this).parent().addClass('active');
    $('.js-tabs-item.active').removeClass('active');
    $('.js-tabs-item[data-index="' + index + '"]').addClass('active');
  });

  $(".owl-carousel").owlCarousel({
    margin: 28,
    items: 1,
    nav: true,
    dots: false,
    responsive: {
      0: {
        items: 1,
      },
      640: {
        items: 2,
      },
      1170: {
        items: 3,
      }
    },
    navText: [
      '<svg width="22" height="19" viewBox="0 0 22 19" xmlns="http://www.w3.org/2000/svg"> ' +
      '<path d="M.228 10.06a.799.799 0 0 1 0-1.12L8.872.23a.784.784 0 0 1 1.11 0 .799.799 0 0 1 0 1.119L2.68 8.709h18.535a.791.791 0 0 1 0 1.583H2.68l7.303 7.36a.799.799 0 0 1 0 1.118.784.784 0 0 1-1.11 0L.228 10.06z" fill="#000" fill-rule="nonzero"/> ' +
      '</svg>',
      '<svg width="22" height="19" viewBox="0 0 22 19" xmlns="http://www.w3.org/2000/svg">\n' +
      '    <path d="M21.772 10.06a.799.799 0 0 0 0-1.12L13.128.23a.784.784 0 0 0-1.11 0 .799.799 0 0 0 0 1.119l7.303 7.36H.786a.791.791 0 0 0 0 1.583H19.32l-7.303 7.36a.799.799 0 0 0 0 1.118.784.784 0 0 0 1.11 0l8.644-8.71z" fill="#000" fill-rule="nonzero"/>\n' +
      '</svg>'
    ]
  });

  $('a[href^="#"]').click(function (e) {
    e.preventDefault();

    scrollToAnchor($($(this).attr('href')));
  });

  $('.js-private-brand-list a').click(function (e) {
    e.preventDefault();
    let index = $(this).data('index');

    $('.js-private-brand-list .is-active').removeClass('is-active');
    $(this).addClass('is-active');

    $('.js-private-brand-image.is-active').removeClass('is-active');
    $('.js-private-brand-image[data-index="' + index + '"]').addClass('is-active');
  });
});